import React from "react";
import { Col, Row, Carousel } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Quote from "../../../assets/images/quoteBegin.svg";
import { truncateText } from "../../../constant/TruncateText";
import { dev } from "../../../features/network/ApiCall";
import LeaderMessageModal from "../modals/LeaderMessageModal";
import "./MessageItem.css";

const MessageItem = ({ editMessagelist }: { editMessagelist: any }) => {
  //console.log(item ,'...........')
  return (
    <>
      {editMessagelist.map((item: any) => {
        return (
          <div className='desk' key={item.id}>
            <Row style={styles.row}>
              <Col
                xxl={2}
                lg={2}
                sm={3}
                className='section-photo'
                // style={{ backgroundColor: "#faf9f9", padding: "30px 35px" }}
              >
                <Image
                  src={`${dev}/admin/download?fileName=${item.image}`}
                  style={{ width: '70px', height: '70px', borderRadius: '50%' }}
                />
              </Col>
              <Col
                xxl={10}
                lg={10}
                sm={9}
                style={{ padding: '20px 10px 10px 40px' }}
              >
                <div
                  style={{ fontSize: '14px', fontWeight: 'bold' }}
                  className='mb-0'
                >
                  {item.name}
                </div>
                <p style={{ fontWeight: 'normal', fontSize: '13px' }}>
                  {item.designation}
                </p>
                <div className='msg'>
                  <div className='quote-img'>
                    <Image
                      src={Quote}
                      style={{ paddingBottom: '10px' }}
                      roundedCircle
                      height={30}
                    />
                  </div>
                  <p style={styles.name}>
                    {truncateText(item.message, 70)}
                    <br />
                  </p>
                </div>
                <span style={{ float: 'right' }}>
                  <LeaderMessageModal type={1} item={item} />
                </span>
              </Col>
            </Row>
          </div>
        );
      })}

      <div className="mob">
        <Carousel>
          {editMessagelist.map((item: any) => {
            return (
              <Carousel.Item key={item.id}>
                <Row style={styles.row}>
                  <Col xs={3} className="section-photo mobphotobg">
                    <Image
                      src={`${dev}/admin/download?fileName=${item.image}`}
                      style={{ width: "80px", borderRadius: "50%" }}
                    />
                  </Col>
                  <Col xs={9} className="section-quote">
                    <div className="mobleadercontent">
                      <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {item.name}
                      </h4>
                      <p style={{ fontWeight: "normal", fontSize: "13px" }}>
                        {item.designation}
                      </p>
                      <Image
                        src={Quote}
                        style={{ paddingBottom: "10px" }}
                        roundedCircle
                      />
                      <p style={styles.name}>
                        {truncateText(item.message, 50)}
                        <br />
                      </p>
                      <span style={{ float: "right" }}>
                        <LeaderMessageModal type={1} item={item} />
                      </span>
                    </div>
                  </Col>
                </Row>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
    </>
  );
};

const styles: any = {
  row: {
    border: "3px solid #faf9f9",
    margin: "20px 1px 0px",
  },
  name: {
    textAlign: "justify",
    // fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "bold",
  },
};

export default MessageItem;
